export default __webpack_public_path__ + "static/media/FilePdfFilled.8993ea2e.svg";